/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.ShippingFees {
    "use strict";


    export class ShippingFeesContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {

        businessTypeCriteria: any;

        constructor(
            appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.BaseClasses.IDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            protected busyService: Meevo.Components.Busy.IBusyService
        ) {

            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService, null, false);


            this.baseEndpoint = appSettings.API_ENDPOINTS.shippingFees;
            this.sectionTemplatePath = "app/plugins/shippingFees/sectionViews/";

            this.entityType = 'ShippingFee';
            this.initializeSections();
        }

        initializeSections(): void {
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MANAGEMENT_EGIFT_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new ShippingFeeMainSection(0,
                    'SECTION_MAIN',
                    'shippingFees.main.section.html',
                    true,
                    false,
                    this.appSettings.API_ENDPOINTS.shippingFees,
                    "",
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Model.NounEnum.ShippingFeeMain
                ));
            }

            if (this.customDataContextConfig && this.customDataContextConfig.appAreaTabs.length > 0) {
                this.renderCustomSections();
            }

        }

        onBusinessTypeChange(): void {
            if (this.selectedSection instanceof ShippingFeeMainSection) {
            }
        }

        preSave() {
            super.save();
        }

        selectSection(item): void {
            super.selectSection(item);
        }

        initializeHeader(model: any): void {
            this.headerContent = model.displayName;
            this.businessTypeDetail = model.businessTypeDetail;
        }
    }
}